<template>
  <div id="cart-sidebar-container">
    <div id="main-curtain" class="overly-mask" :class="{'is-visible': showCart}" @click="hideCartSidebar()"></div>
    <aside class="cart-sidebar" :class="{'is-visible': showCart}">
      <div class="cart-sidebar-content row mx-0">

        <div class="cartMenu col-xs-12 no-margin-no-padding open">

          <div class="cart-sidebar-header">
            <h3> {{ $t('cart.cart') }} </h3>

            <div class="cart-close-trigger align-top">
              <button class="close" type="button" @click="hideCartSidebar()">
                <span aria-hidden="true">×</span>
              </button>
            </div>
          </div>

          <div class="w100 scroll-pane" style="overflow-y: scroll">
            <table class="w-100">
              <tbody>
                <tr class="miniCartProduct" v-for="c in carts" :key="c.id">
                  <td class="pl-10">
                    <el-checkbox
                        v-model="checkoutIds"
                        :label="c.id"
                        :key="c.id"
                        @change="handlerChangeSelected()"
                    >
                      &nbsp;
                    </el-checkbox>
                  </td>
                  <td class="miniCartProductThumb pl-10 pr-10" style="width: 30%">
                    <div>
                      <router-link class="demo-upload-list" :to="{ name: 'product', params: { productId: c.product_id, specificationId: c.product_specification_id } }">
                        <img class="img-list" :alt="c.product_name" :src="c.image" />
                      </router-link>
                    </div>
                  </td>
                  <td style="width: 60%">
                    <div class="miniCartDescription">
                      <h4>
                        <router-link :to="{ name: 'product', params: { productId: c.product_id, specificationId: c.product_specification_id } }">
                          {{ c.product_name }}
                        </router-link>
                      </h4>
                      <span class="size" v-if="c.spec"> {{ c.spec.name }} </span>

                      <div><span class="price"> {{ c.unit_price | currency(c.currency) }}</span>  &times; {{ c.quantity }}</div>

                      <div>
                        <span v-if="c.before_price && c.before_price > c.unit_price" class="text-success">{{ $t('cart.it_is_cheaper') }}</span>
                        <span v-else-if="c.before_price && c.before_price < c.unit_price" class="text-danger">{{ $t('cart.it_is_expensive') }}</span>
                      </div>
                    </div>
                  </td>
                  <td class="delete" style="width: 10%" v-if="deleteBtnDisabled">
                    <button type="button" class="close" @click="removeCart(c.id)">
                      <span aria-hidden="true">×</span>
                    </button>
                  </td>
                </tr>

                <!-- rakuten -->
                <template v-if="rakuten.length">
                  <tr>
                    <td colspan="3" class="third-party-shop-title"><h3>{{ $t('shop_names.rakuten') }}</h3></td>
                  </tr>
                  <tr class="miniCartProduct" v-for="c in rakuten" :key="c.itemCode">
                    <td class="miniCartProductThumb pl-10 pr-10" style="width: 30%">
                      <div>
                        <router-link :to="{ name: 'rakuten-product-detail', params: { itemCode: c.product_id } }">
                          <img :alt="c.product_name" :src="c.product_image" />
                        </router-link>
                      </div>
                    </td>
                    <td style="width: 60%">
                      <div class="miniCartDescription">
                        <h4>
                          <router-link :to="{ name: 'rakuten-product-detail', params: { itemCode: c.product_id } }">
                            {{ c.product_name }}
                          </router-link>
                        </h4>
                        <div><span class="price"> {{ c.unit_price | currency }}</span>  &times; {{ c.quantity }}</div>
                      </div>
                    </td>

                    <td class="delete" style="width: 10%" v-if="deleteBtnDisabled">
                      <button type="button" class="close" @click="removeThridPartyShopCart(c.shop_name, c.id)">
                        <span aria-hidden="true">×</span>
                      </button>
                    </td>
                  </tr>
                </template>
                <!-- yahoo_jp -->
                <template v-if="yahoo_jp.length">
                  <tr>
                    <td colspan="3" class="third-party-shop-title"><h3>{{ $t('shop_names.yahoo_jp') }}</h3></td>
                  </tr>
                  <tr class="miniCartProduct" v-for="c in yahoo_jp" :key="c.key">
                    <td class="miniCartProductThumb pl-10 pr-10" style="width: 30%">
                      <div>
                        <router-link :to="{ name: 'yahoo_jp-product-detail', params: { code: c.product_id } }">
                          <img :alt="c.product_name" :src="c.product_image" />
                        </router-link>
                      </div>
                    </td>
                    <td style="width: 60%">
                      <div class="miniCartDescription">
                        <h4>
                          <router-link :to="{ name: 'yahoo_jp-product-detail', params: { code: c.product_id } }">
                            {{ c.product_name }}
                          </router-link>
                        </h4>
                        <template v-if="c.extra">
                          <div v-for="(val, key) in c.extra" :key="key">
                            <span class="text-secondary">{{ key }}: {{ val }}</span>
                          </div>
                        </template>
                        <div><span class="price"> {{ c.unit_price | currency(c.currency) }}</span>  &times; {{ c.quantity }}</div>
                      </div>
                    </td>
                    <td class="delete" style="width: 10%" v-if="deleteBtnDisabled">
                      <button type="button" class="close" @click="removeThridPartyShopCart(c.shop_name, c.id, c.extra)">
                        <span aria-hidden="true">×</span>
                      </button>
                    </td>
                  </tr>
                </template>

              </tbody>
            </table>
          </div>
          <!--/.scroll-pane-->

          <div class="miniCartFooter cart-panel-footer clearfix">

            <!--<h3 class="text-right subtotal"> {{ $t('order.total_product') }}: {{ price() }} </h3>-->
            <div class="row mx-0 mt-20" style="display: flex;justify-content: flex-end">
              <div class="col-auto">

                <button class="my-0 btn btn-primary text-white" :disabled="checkoutIds.length === 0"
                        @click="() => $router.push({ name: 'checkout' })">
                  {{ $t('cart.checkout') }}
                </button>
                <!--<router-link :to="{ name: 'cart' }" class="btn btn-primary btn-block my-0" “:disabled="checkoutIds.length" ”>-->
                  <!--{{ $t('order.to_pay') }}<i class="fa fa-arrow-right"></i>-->
                <!--</router-link>-->
              </div>
              <div class="col-auto">
                <router-link :to="{ name: 'cart' }" class="btn btn-danger btn-block my-0">
                  <i class="fa fa-shopping-cart"> </i> {{ $t('cart.view_cart') }}
                </router-link>
              </div>
              <!--<div class="col px-0">-->
                <!--<checkout-btn class="btn-block my-0">-->
                  <!--{{ $t('cart.checkout') }}-->
                <!--</checkout-btn>-->
              <!--</div>-->
            </div>
          </div>
        </div>
      </div>
    </aside>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex';

  export default {
    name: 'CartSideBar',
    data() {
      return {
        checkoutIds: [],
      };
    },
    computed: {
      ...mapState({
        showCart: state => state.cart.showCart,
        carts: state => state.cart.carts,
        rakuten: state => state.cart.rakuten,
        yahoo_jp: state => state.cart.yahoo_jp,
        amazon_jp: state => state.cart.amazon_jp,
      }),
      ...mapGetters({
        totel: 'getCartTotal',
      }),
      deleteBtnDisabled() {
        return this.$route.name !== 'checkout';
      },
    },
    methods: {
      handlerChangeSelected() {
        this.$store.dispatch('setCartSelectedIds', this.checkoutIds);
        this.$store.dispatch('setCheckoutIds', this.checkoutIds);
      },
      // price() {
      //   let okubuy = 0;
      //   if (this.carts.length) {
      //     _.map(this.carts, (val) => {
      //       okubuy = (val.quantity * val.unit_price) + okubuy;
      //       return okubuy;
      //     });
      //   }
      //   if (this.rakuten.length) {
      //     _.map(this.rakuten, (val) => {
      //       okubuy = (val.quantity * val.unit_price) + okubuy;
      //       return okubuy;
      //     });
      //   }
      //   if (this.yahoo_jp.length) {
      //     _.map(this.yahoo_jp, (val) => {
      //       okubuy = (val.quantity * val.unit_price) + okubuy;
      //       return okubuy;
      //     });
      //   }
      //   if (this.amazon_jp.length) {
      //     _.map(this.amazon_jp, (val) => {
      //       okubuy = (val.quantity * val.unit_price) + okubuy;
      //       return okubuy;
      //     });
      //   }
      //   return `${formatMoney(okubuy, currency)}`;
      // },
      hideCartSidebar() {
        this.$store.dispatch('setShowCart', false);
      },
      removeCart(id) {
        this.$store.dispatch('removeCart', id).then(() => {
          this.$notify({
            type: 'success',
            title: this.$t('cart.product_has_been_removed'),
          });
        }).catch((error) => {
          if (error.response) {
            this.$notify({
              type: 'danger',
              title: this.$t('cart.remove_err'),
              message: error.response.data.message,
            });
          }
        });
      },
      removeThridPartyShopCart(shop_name, id, extra) {
        this.$store.dispatch('removeThridPartyShopCart', { shop_name, id, extra }).then(() => {
          this.$notify({
            type: 'success',
            title: this.$t('cart.product_has_been_removed'),
          });
        }).catch((error) => {
          if (error.response) {
            this.$notify({
              type: 'danger',
              title: this.$t('cart.remove_err'),
              message: error.response.data.message,
            });
          }
        });
      },
    },
    components: {
    },
  };
</script>

<style lang="scss">
  @import "../../styles/helpers/variables";
  .demo-upload-list {
    width: 65px;
    height: 65px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }
  .img-list {
    max-width: 100%;
    max-height: 100%;
    cursor: pointer;
  }
  .miniCartDescription{
    width: 100%;
    max-width: 180px;
    h4{
      max-width: 180px;
      a{
        display: block;
        max-width: 180px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  .overly-mask,
  .menu-overly-mask {
    background-color: $black-color;
    height: 100%;
    left: 0;
    opacity: 0;
    position: fixed;
    top: 0;
    transition: all 0.5s ease-in-out 0s;
    -webkit-transition: all 0.5s ease-in-out 0s;
    -o-transition: all 0.5s ease-in-out 0s;
    visibility: hidden;
    width: 100%;
    z-index: 9011;
  }

  .overly-mask {
    &.is-visible {
      cursor: pointer;
      opacity: 0.25;
      visibility: visible;
    }
  }

  .menu-overly-mask {
    &.is-visible {
      cursor: pointer;
      opacity: 0.55;
      visibility: visible;
    }
  }

  .cart-sidebar-content,
  .menu-sidebar-content {
    height: 100%;
    width: 100%;
    position: relative;
    display: block;
  }

  .menu-sidebar-content {
    border-right: 1px solid rgba(0, 0, 0, 0.05);
    .inner {
      padding: 48px;
    }
    .menu-sidebar-header {
      h3 {
        text-transform: uppercase;
        letter-spacing: 2px;
        font-size: 32px;
        font-weight: 700;
      }
    }
  }

  .cart-sidebar {
    background-color: $white-color;
    bottom: 0;
    color: #333;
    margin: 0;
    overflow: auto;
    padding: 0;
    position: fixed;
    right: -360px;
    transition: right 200ms cubic-bezier(0.645, 0.045, 0.355, 1) 0s;
    -webkit-transition: right 200ms cubic-bezier(0.645, 0.045, 0.355, 1) 0s;
    -moz-transition: right 200ms cubic-bezier(0.645, 0.045, 0.355, 1) 0s;
    -ms-transition: right 200ms cubic-bezier(0.645, 0.045, 0.355, 1) 0s;
    -o-transition: right 200ms cubic-bezier(0.645, 0.045, 0.355, 1) 0s;
    width: 360px;
    z-index: 10000;
    top: 0;
    .cart-sidebar-header {
      background: $brand-primary;
      padding: 15px;
      height: 50px;
      h3 {
        color: $white-color;
        font-family: Oswald, Helvetica Neue, Helvetica, Arial, sans-serif;
        font-size: 14px;
        font-weight: unset;
        letter-spacing: 1px;
        margin-bottom: 0;
        padding-bottom: 0;
        text-transform: uppercase;
      }
      .cart-close-trigger {
        position: absolute;
        right: 15px;
        top: 7px;
        font-size: 30px;
        color: $gray-light;
        .close {
          color: $white-color;
          float: right;
          font-size: 28px;
          font-weight: normal;
          line-height: 1;
          opacity: 1;
          text-shadow: none;
          &:hover {
            color: $white-color;
          }
        }
      }
    }
    .cartMenu {
      height: 100%;
      padding: 0;
      border-left: 1px solid #e1e7ec;
      .scroll-pane {
        height: calc(100% - 95px - 51px);
        .mCSB_container {
          margin-right: 12px;
        }
      }
      table {
        tr {
          td {
            padding: 10px 0;
            &.delete {
              padding-left: 10px;
              padding-right: 10px;
              button {
                &.close {
                  float: left;
                }
              }
            }
          }
          &:last-child {
            border-bottom: none;
          }
        }
      }
    }
    .miniCartProduct {
      -webkit-transition: all 0.25s linear 0s;
      -moz-transition: all 0.25s linear 0s;
      -o-transition: all 0.25s linear 0s;
      -ms-transition: all 0.25s linear 0s;
      transition: all 0.25s linear 0s;
      &:hover {
        background: $white-color;
      }
      a {
        color: #333;
        text-decoration: none;
        font-size: 14px
      }
    }
    .subtotal {
      padding-bottom: 0;
      padding-right: 5px;
      font-size: 1.2em;
    }
    .cart-panel-footer {
      .col-sm-6 {
        padding: 10px 5px;
      }
    }
    &.is-visible {
      right: 0;
    }
  }

  .menu-sidebar {
    background-color: $white-color;
    bottom: 0;
    color: #333;
    margin: 0;
    overflow: auto;
    padding: 0;
    position: fixed;
    left: -300px;
    transition: left 200ms cubic-bezier(0.645, 0.045, 0.355, 1) 0s;
    -webkit-transition: left 200ms cubic-bezier(0.645, 0.045, 0.355, 1) 0s;
    -moz-transition: left 200ms cubic-bezier(0.645, 0.045, 0.355, 1) 0s;
    -ms-transition: left 200ms cubic-bezier(0.645, 0.045, 0.355, 1) 0s;
    -o-transition: left 200ms cubic-bezier(0.645, 0.045, 0.355, 1) 0s;
    width: 300px;
    z-index: 10000;
    top: 0;
    .cart-sidebar-content {
      height: 100%;
      width: 100%;
      position: relative;
      display: block;
    }
    &.is-visible {
      left: 0;
    }
  }

  .nav-tree-light {
    margin-top: 30px;
    li {
      & > a {
        text-transform: uppercase;
      }
      a {
        background: rgba(0, 0, 0, 0) none repeat scroll 0 0 !important;
        border: medium none;
        color: #333;
        font-size: 13px;
        font-weight: 400;
        letter-spacing: 2px;
        padding: 16px 0;
        text-decoration: none;
        &:hover {
          opacity: .75;
        }
      }
      ul {
        background: none !important;
        a {
          font-size: 12px;
          padding: 10px 0 10px 15px;
        }
      }
    }
  }

  .third-party-shop-title {
    font-weight: bold;
    padding: 15px !important;
    height: 50px;
    background: $brand-primary;
    h3 {
      color: $white-color;
      font-family: Oswald, Helvetica Neue, Helvetica, Arial, sans-serif;
      font-size: 14px;
      font-weight: unset;
      letter-spacing: 1px;
      margin-bottom: 0;
      padding-bottom: 0;
    }
  }
</style>
